import * as React from 'react';
import {Image as BaseImage} from '@web-utilities/types';

import {Image} from './components';
import {Mode} from './types';
import styles from './ImageGrid.scss';

interface LoadingImage extends BaseImage {
  loading?: boolean;
}

type Selected = string[];

export interface Props {
  images: LoadingImage[];
  selected: Selected | null;
  onImageClick(image: BaseImage): void;
  renderBeforeImages?(): React.ReactNode;
  disabled?: boolean;
  findSelectedImages?(image: LoadingImage, selected: Selected): boolean;
  mode?: Mode;
}

function ImageGrid({
  images,
  selected: selectedKeys,
  disabled,
  onImageClick,
  renderBeforeImages,
  findSelectedImages = imageIsSelected,
  mode,
}: Props) {
  const imagesMarkup = images.map(({loading, ...image}) => {
    const selected =
      selectedKeys !== null && findSelectedImages(image, selectedKeys);

    return (
      <li key={image.src}>
        <Image
          key={image.src}
          image={image}
          loading={loading}
          selected={selected}
          disabled={disabled && !selected}
          onImageClick={onImageClick}
          mode={mode}
        />
      </li>
    );
  });

  const beforeImagesMarkup = renderBeforeImages ? renderBeforeImages() : null;

  return (
    <ul className={styles.ImageGrid}>
      {beforeImagesMarkup}
      {imagesMarkup}
    </ul>
  );
}

function imageIsSelected(image: LoadingImage, selected: Selected) {
  return selected.some((id) => id === image.id);
}

export default ImageGrid;
